import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { emailContentQueryKeys } from "./queryKeys";
import { EmailContentUpdate } from "./../../models/emailContent/EmailContent";

export function useEmailContentMutations(
  agencyId: string,
  emailTemplateId: string
) {
  const queryClient = useQueryClient();
  const { put, del } = useApiHelper();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("Email Template");

  const update = useMutation(
    (data: EmailContentUpdate) =>
      put(`/emailtemplate/${emailTemplateId}/contents/${agencyId}`, data),
    {
      ...saveHandlers,
      onSuccess: (_) => {
        queryClient.invalidateQueries(
          emailContentQueryKeys.byAgencyId(agencyId)
        );
        saveHandlers.onSuccess?.();
      },
    }
  );

  const remove = useMutation(
    () => del(`/emailtemplate/${emailTemplateId}/contents/${agencyId}`),
    {
      ...deleteHandlers,
      onSuccess: (_) => {
        queryClient.invalidateQueries(
          emailContentQueryKeys.byAgencyId(agencyId)
        );
        deleteHandlers.onSuccess?.();
      },
    }
  );

  return {
    update,
    remove,
  };
}
